export {default as exclamationMark }from "./Icons"